var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#27B0D4",
    strokeLinecap: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.759 24.688v4.848c0 .461-.048.628-.139.797a.94.94 0 0 1-.39.39c-.17.091-.336.14-.798.14H5.326c-.461 0-.628-.049-.797-.14a.94.94 0 0 1-.39-.39c-.091-.169-.139-.336-.139-.797V9.43c0-.462.048-.629.138-.797a.94.94 0 0 1 .391-.391c.169-.09.336-.139.797-.139h13.172"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M27.38 19.069l6.206-6.828-6.207-6.827"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.38 23.892c.055-9.17 3.848-11.68 12.58-11.65.843.003 2.167.003 3.971 0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddNew);
export default __webpack_public_path__ + "static/media/AddNew.fccd6211e175684aa099a533670e788c.svg";
export { ForwardRef as ReactComponent };